import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=4099c54c&scoped=true"
import script from "./OrganizationForm.vue?vue&type=script&lang=js"
export * from "./OrganizationForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizationForm.vue?vue&type=style&index=0&id=4099c54c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099c54c",
  null
  
)

export default component.exports